import React from 'react'
import './blueconic.scss'
import { GetBlueConicDomainIntegrationResponse } from '@pushly/models/lib/structs/domains'
import { DomainIntegrationProviders } from '@pushly/models/lib/enums/domain-integration-providers'
import { Descriptions } from 'antd'
import { PlatformIntegrationCard } from '../../../platform-integrations/platform-integration-card/platform-integration-card'
import { BlueConicLogo } from '../../../icons/blueconic-logo'
import { EditOutlined } from '@ant-design/icons'
import { IntegrationProps } from '../../interfaces'

export const BlueConicIntegration: React.FC<IntegrationProps<GetBlueConicDomainIntegrationResponse>> = (props) => {
    const { className, loading, mode, onActionClick } = props

    const integration = mode === 'edit' ? props.integration : null
    const storeIds = integration ? Object.keys(integration.data.stores) : []

    return (
        <PlatformIntegrationCard
            loading={loading}
            className={className}
            provider={DomainIntegrationProviders.BLUECONIC_REC}
            logo={<BlueConicLogo />}
            mode={mode}
            isActive={integration?.is_active}
            actions={{
                primary: {
                    onClick: () => {
                        if (mode === 'add') {
                            onActionClick?.('primary')
                            return
                        }

                        if (!integration) return
                        onActionClick?.('primary', integration) // dispatch({ type: 'rem-integration', integration })
                    },
                },
                secondary:
                    mode === 'add'
                        ? undefined
                        : {
                              title: 'Edit',
                              icon: <EditOutlined />,
                              onClick: () => {
                                  if (!integration) return
                                  onActionClick?.('secondary', integration) // dispatch({ type: 'edit-integration', integration })
                              },
                          },
            }}
        >
            {!loading && integration && (
                <Descriptions layout="horizontal" column={1}>
                    <Descriptions.Item label="Name">{integration.data.name}</Descriptions.Item>
                    <Descriptions.Item label="Tenant">{integration.data.tenant_name}</Descriptions.Item>
                    <Descriptions.Item label="Stores">{storeIds.length}</Descriptions.Item>
                </Descriptions>
            )}
        </PlatformIntegrationCard>
    )
}
